const refreshUrlFromLocation = () => {
    const next = new URL(window.location.href);
    url = next;
    searchParams = next.searchParams;
};

let url = new URL(window.location.href);
let searchParams = url.searchParams;

const HEAD = ".directory-head-bottom";

const fadeIn = (el, display) => {
    el.style.opacity = 0;
    el.style.display = display || "block";
    (function fade() {
        let val = parseFloat(el.style.opacity);
        if (!((val += 0.055) > 1)) {
            el.style.opacity = val;
            requestAnimationFrame(fade);
        }
    })();
};

const indexInParent = (node) => {
    const children = node.parentNode.childNodes;
    let num = 0;
    for (let i = 0; i < children.length; i++) {
        if (children[i] === node) return num;
        if (children[i].nodeType === 1) num++;
    }
    return -1;
};

const getEffectiveCategory = () => {
    refreshUrlFromLocation();
    const c = searchParams.get("category");
    return c || null;
};

const firstMainGridTitle = (handle) => {
    let out = "";
    document.querySelectorAll(`.directory-list-best-grid[data-category-handle="${handle}"]`).forEach((el) => {
        const t = (el.getAttribute("data-main-grid-title") || "").trim();
        if (t && !out) out = t;
    });
    return out;
};

const buildFallbackTitleFromCategoryAttr = (rawCategory) => {
    let titleText = rawCategory || "";
    if (!titleText) return "";
    const lastCharacter = titleText[titleText.length - 1].toLowerCase();
    if (lastCharacter !== "s") {
        titleText = `${titleText}s`;
    }
    if (lastCharacter === "y") {
        titleText = `${titleText.slice(0, -1)}ies`;
    }
    return titleText.replace(/\s+/g, "");
};

/**
 * @param {string|null|undefined} cat — Omit to call getEffectiveCategory() internally.
 */
const updateGridTitle = (cat) => {
    const resolved = cat !== undefined ? cat : getEffectiveCategory();
    const $gridTitle = document.querySelector(".directory-list-grid-title");
    if (!$gridTitle) return;

    if (resolved) {
        const firstItem = document.querySelector(`.directory-list-grid-item[data-category-handle="${resolved}"]`);
        if (!firstItem) return;
        const raw = firstItem.getAttribute("data-category") || "";
        if (!raw) return;
        const main = firstMainGridTitle(resolved);
        const fallback = buildFallbackTitleFromCategoryAttr(raw);
        $gridTitle.textContent = main ? main : `${fallback} A-Z`;
    } else {
        $gridTitle.textContent = firstMainGridTitle("all") || "Directory A-Z";
    }
};

const handleGridUpdate = () => {
    const cat = getEffectiveCategory();
    updateGridTitle(cat);
    const $gridItems = document.querySelectorAll(".directory-list-grid .directory-list-grid-item");

    if (cat) {
        const firstItem = document.querySelector(`.directory-list-grid-item[data-category-handle="${cat}"]`);
        if (!firstItem) return;
        $gridItems.forEach(($item) => {
            $item.style.display = "none";
        });
        document.querySelectorAll(`.directory-list-grid-item[data-category-handle="${cat}"]`).forEach(($item) => {
            fadeIn($item, "flex");
        });
        if (document.querySelector(".directory-list-best-grid")) {
            document.querySelectorAll(".directory-list-best-grid").forEach(($grid) => {
                $grid.style.display = "none";
            });
            document.querySelectorAll(`.directory-list-best-grid[data-category-handle="${cat}"]`).forEach(($grid) => {
                fadeIn($grid, "grid");
            });
        }
    } else {
        $gridItems.forEach(($item) => fadeIn($item, "flex"));
        if (document.querySelector(".directory-list-best-grid")) {
            document.querySelectorAll(".directory-list-best-grid").forEach(($grid) => {
                $grid.style.display = "none";
            });
            if (document.querySelector('.directory-list-best-grid[data-category-handle="all"]')) {
                document.querySelectorAll('.directory-list-best-grid[data-category-handle="all"]').forEach(($grid) => {
                    fadeIn($grid, "grid");
                });
            }
        }
    }
};

const commitSearchParams = () => {
    url.search = searchParams.toString();
    history.replaceState({}, null, url.toString());
};

const clearNavActive = () => {
    document.querySelectorAll(`${HEAD} a`).forEach((a) => a.classList.remove("active"));
};

const activateViewAllNav = () => {
    const first = document.querySelector(`${HEAD} ul li:first-child a`);
    if (first) first.classList.add("active");
};

const categoryFromNavHref = (href) => {
    try {
        return new URL(href).searchParams.get("category");
    } catch {
        const part = href.split("?category=")[1];
        return part ? part.split("&")[0] : null;
    }
};

const syncCategoryFromHandle = (handle) => {
    refreshUrlFromLocation();
    const normalized = String(handle || "").trim().toLowerCase();
    const isAll = !normalized || normalized === "all";

    clearNavActive();

    if (isAll) {
        searchParams.delete("category");
        activateViewAllNav();
    } else {
        searchParams.set("category", normalized);
        document.querySelectorAll(`${HEAD} a`).forEach((a) => {
            const href = a.getAttribute("href") || "";
            if (href.includes(`category=${normalized}`)) {
                a.classList.add("active");
            }
        });
    }

    commitSearchParams();

    const $select = document.querySelector(`${HEAD} select`);
    if ($select) {
        $select.value = isAll ? "" : normalized;
    }

    handleGridUpdate();
};

document.addEventListener("change", (e) => {
    const $select = e.target.closest?.(`${HEAD} select`);
    if (!$select || $select.name !== "catgegory") return;

    const value = $select.value;
    const selectedOption = Array.from($select.options).find((o) => o.value === value);
    if (!selectedOption) return;
    const index = indexInParent(selectedOption);

    clearNavActive();

    if (value === "") {
        activateViewAllNav();
        searchParams.delete("category");
    } else {
        const $navLinks = document.querySelectorAll(`${HEAD} a`);
        if ($navLinks[index]) $navLinks[index].classList.add("active");
        searchParams.set("category", value);
    }

    commitSearchParams();
    handleGridUpdate();
});

document.addEventListener("click", (e) => {
    const $link = e.target.closest?.(`${HEAD} a`);
    if (!$link) return;
    e.preventDefault();

    const cat = categoryFromNavHref($link.href);
    if (cat == null) return;

    clearNavActive();

    if (cat === "all") {
        searchParams.delete("category");
        activateViewAllNav();
    } else {
        $link.classList.add("active");
        searchParams.set("category", cat);
    }

    const $select = document.querySelector(`${HEAD} select`);
    if ($select) {
        $select.value = cat === "all" ? "" : cat;
    }

    commitSearchParams();
    handleGridUpdate();
});

document.addEventListener("shopify:block:select", (event) => {
    if (!window.Shopify?.designMode) return;
    const grid = event.target.closest?.(".directory-list-best-grid");
    if (!grid) return;
    const handle = grid.getAttribute("data-category-handle");
    if (!handle) return;
    syncCategoryFromHandle(handle);
});

document.addEventListener("shopify:section:load", () => {
    handleGridUpdate();
});

updateGridTitle();
